import { useQuery } from "react-query";
import { getOfficeStates } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeStates = () => {
  return useQuery("GetOfficeStates", getOfficeStates, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
